export default __webpack_public_path__ + "static/iso-certified-1a7f082e215b2997c64c899fcb224afc.svg";